import { Suspense, lazy } from "react";
import { HashRouter, Route, Routes } from "react-router-dom";

import Home from './components/pages/Home';
import Login from './components/pages/Login';
import App from "./App";
import NotFound from "./components/pages/errors/NotFound";
import AccessDenied from "./components/pages/errors/AccessDenied";
import InternalError from "./components/pages/errors/InternalError";
import Logout from "./components/pages/Logout";
import Chat from "./components/pages/chat/Chat";

import NetworkError from "./components/pages/errors/NetworkError";

import LegalPersonPageList from "./components/pages/person/legal_person/LegalPersonPageList";
import IndividualPageList from "./components/pages/person/individual/IndividualPageList";
import IndividualPageForm from "./components/pages/person/individual/IndividualPageForm";
import IndividualPageEdit from "./components/pages/person/individual/IndividualPageEdit";


import LegalPersonPageForm from "./components/pages/person/legal_person/LegalPersonPageForm";

import MaintenanceFormPage from "./components/pages/maintenance/MaintenanceForm";

import ScoreAgrolendModal from "./components/pages/referrals/ScoreAgrolendModal";
import Loading from "./components/ions/Loading";
import BiroListModal from "./components/pages/referrals/BiroListModal";
import BiroVariablesModal from "./components/pages/referrals/BiroVariablesModal";
import BiroDocumentModal from "./components/pages/referrals/BiroDocumentModal";
import ReferralDetailModal from "./components/pages/referrals/ReferralDetailModal";

import ReferralPartnerAnalysisListPage from './components/pages/referrals/PartnerAnalysisList';
import CreditLimitAnalysisForm from "./components/pages/referrals/CreditLimitAnalysisForm";
import ReferralPartnerAnalyzedListPage from './components/pages/referrals/PartnerAnalyzedList';
import RequireAuth from "./services/Auth/RequireAuth";
import { ROLES } from "./services/Auth/roles";

import FarmerOrderListPage from './components/pages/referrals/FarmerOrderList';

import BatchAnalysisListPage from "./components/pages/referrals/BatchAnalysisList";
import BatchAnalysisFormPage from "./components/pages/referrals/BatchAnalysisForm";
import BatchAnalysisView from "./components/pages/referrals/BatchAnalysisView";

import CommercialPage from "./components/pages/commercial/CommercialPage";
import CommercialFormPage from "./components/pages/commercial/CommercialFormPage";

import FeatureFlagReferral from './components/pages/configuration/FeatureFlagReferralListPage';
import FeatureFlagReferralView from "./components/pages/configuration/FeatureFlagReferralViewPage";
import ReasonPageList from "./components/pages/referrals/ReasonPageList";
import ReasonFormModal from "./components/pages/referrals/ReasonFormModal";
import ReferralConfiguration from "./components/pages/referrals/ReferralConfiguration";
import LoanOrderAnalysisForm from "./components/pages/referrals/LoanOrderAnalysisForm";
import FarmerOrderUnlinkedListPage from "./components/pages/referrals/FarmerOrderUnlinkedList";
import LinkUpReferralWithLoanOrderFormPage from "./components/pages/referrals/LinkUpReferralWithLoanOrderForm";
import ReferralLoanOrderRejectedListPage from "./components/pages/referrals/ReferralLoanOrderRejectedList";
import LoanOrderAnalysisListPage from "./components/pages/referrals/LoanOrderAnalysisList";

import NotificationPageList from "./components/pages/communication/NotificationPageList";
import NotificationCalendarPage from "./components/pages/communication/NotificationCalendar";

import BatchNotificationForm from "./components/pages/communication/BatchNotifcationForm";
import CommunicationConfiguration from "./components/pages/communication/CommunicationConfiguration";
import MessageCompositionPageList from "./components/pages/communication/MessageCompositionPageList";
import MessageCompositionStudioPage from "./components/pages/communication/composition/studio/MessageCompositionStudioPage";
import TemplatePageList from "./components/pages/communication/TemplatePageList";
import TemplateStudioPage from "./components/pages/communication/template/TemplateStudioPage";
import GroupPageList from "./components/pages/communication/GroupPageList";
import GroupNewDrawerRoute from "./components/pages/communication/group/GroupNewDrawerRoute";
import GroupDrawerRoute from "./components/pages/communication/group/GroupDrawerRoute";
import RoutingPageList from "./components/pages/communication/RoutingPageList";
import RoutingViewPage from "./components/pages/communication/RoutingViewPage";
import { ContactPageList } from "./components/pages/communication/contact/ContactPageList";
import ContactPageView from "./components/pages/communication/contact/ContactPageView";
import ContactPointModalFormRoute from "./components/pages/communication/contact/ContactPointModalFormRoute";
import ContactModalEditRoute from "./components/pages/communication/contact/ContactModalEditRoute";
import CallRegistryModalFormRoute from "./components/pages/communication/contact/CallRegistryModalFormRoute";

import UserPageList from "./components/pages/user/UserPageList";
import UserPageView from "./components/pages/user/UserPageView";

import ContractDisbursementList from "./components/pages/financial/ContractDisbursementList";
import LoanFormPage from "./components/pages/loan/LoanForm";
import FarmerDataViewPage from "./components/pages/farmer/FarmerDataView";
import FarmerPageList from "./components/pages/loan/FarmerPageList";
import SelectProfilesModal from "./components/pages/person/shared/SelectProfilesModal";
import LegalPersonPageEdit from "./components/pages/person/legal_person/LegalPersonPageEdit";
import SignatoryListPage from "./components/pages/person/legal_person/SignatoryListPage";
import BlockListPage from "./components/pages/referrals/BlockListPage";
import BlockListInputForm from "./components/pages/referrals/BlockListInputForm";
import BlockListChanged from "./components/pages/referrals/BlockListChanged";

import ReportTypePageList from "./components/pages/data-provider/ReportTypePageList";
import ReportTypePageForm from "./components/pages/data-provider/ReportTypePageForm";
import ReportTypePageView from "./components/pages/data-provider/ReportTypePageView";
import BatchReportPageForm from "./components/pages/data-provider/BatchReportPageForm";
import BatchReportPageList from "./components/pages/data-provider/BatchReportPageList";
import BatchReportPageView from "./components/pages/data-provider/BatchReportPageView";
import ReportPageView from "./components/pages/data-provider/ReportPageView";
import AnnualProviderReportPageList from "./components/pages/data-provider/AnnualProviderReportPageList";
import SoftwarePortfolioPageList from "./components/pages/ti/SoftwarePortfolioPageList";
import SoftwareAnalysisPageView from "./components/pages/ti/SoftwareAnalysisPageView";
import SoftwareAnalysisDetailPageView from "./components/pages/ti/SoftwareAnalysisDetailPageView";
import EventPlatformPageView from "./components/pages/ti/event-platform/EventPlatformPageView";
import SicorReportPageList from "./components/pages/sicor/ReportPageList";
import SicorDocumentPageList from "./components/pages/sicor/DocumentPageList";
import SicorDocumentPageView from "./components/pages/sicor/DocumentPageView";

import RecommendationEngineRulesList from "./components/pages/recommendation-engine/RecommendationEnginePageList";
import RecommendationEnginePageForm from "./components/pages/recommendation-engine/RecommendationEnginePageForm";
import RecommendationEnginePageView from "./components/pages/recommendation-engine/RecommendationEnginePageView";
import RecommendationEngineRecommendationsList from "./components/pages/recommendation-engine/RecommendationEngineRecommendationsList";
import RecommendationEngineRecommendationView from "./components/pages/recommendation-engine/RecommendationEngineRecommendationView";
import RecommendationEngineParecerView from "./components/pages/recommendation-engine/RecommendationEngineParecerView";
import ProviderDocumentsGrid from "./components/pages/recommendation-engine/ProviderDocumentsGrid";

import MonitoringPage from "./components/pages/monitoring/MonitoringPage";

import FilePageList from "./components/pages/legal/FilePageList";
import FileLinkModalForm from "./components/pages/legal/FileLinkModalForm";
import CreditOperationPageList from "./components/pages/legal/CreditOperationPageList";

import OperationsPage from "./components/pages/operations/OperationsPage";
import OperationReceivablesAssignmentFormPage from "./components/pages/operations/OperationReceivablesAssignmentFormPage";
import OperationLoanFormPage from "./components/pages/operations/OperationLoanFormPage";
import ReceivablesAssignmentPage from "./components/pages/operations/ReceivablesAssignmentPage";
import CreditAnalysisMain from "./components/pages/credit-analysis/CreditAnalysisMain";
import CreditAnalysisPageForm from "./components/pages/credit-analysis/CreditAnalysisPageForm";
import { BatchProcessingDetail } from "./components/pages/credit-analysis/BatchProcessingDetail";
import CreditAnalysisBatchView from "./components/pages/credit-analysis/BatchAnalysisView";
// Gestão de Documentos (AF-4107) desativada — ver pages/document-management/README.md.

import StructuredOperationPage from "./components/pages/operations/StructuredOperationPage";
import AcknowledgementDebtPage from "./components/pages/operations/AcknowledgementDebtPage";
import CreateDraweeRiskPage from "./components/pages/operations/CreateDraweeRiskPage";
import DraweeRiskViewPage from "./components/pages/operations/DraweeRiskViewPage";

import OperationPageList from "./components/pages/structuring/OperationPageList";
import OperationPageForm from "./components/pages/structuring/OperationPageForm";
import OperationPageView from "./components/pages/structuring/OperationPageView";
import DraweeConfirmationPageList from "./components/pages/collateral/DraweeConfirmationPageList";
import ReceivablePageList from "./components/pages/collateral/ReceivablePageList";
import CreditRightPageList from "./components/pages/collateral/CreditRightPageList";
import CreditRightBatchPageList from "./components/pages/collateral/CreditRightBatchPageList";
import CreditRightBatchPageView from "./components/pages/collateral/CreditRightBatchPageView";
import VehicleAssetPageList from "./components/pages/collateral/VehicleAssetPageList";
import VehicleAssetPageForm from "./components/pages/collateral/VehicleAssetPageForm";
import PropertyAssetPageList from "./components/pages/collateral/PropertyAssetPageList";
import PropertyAssetPageForm from "./components/pages/collateral/PropertyAssetPageForm";
import MachineryAssetPageList from "./components/pages/collateral/MachineryAssetPageList";
import MachineryAssetPageForm from "./components/pages/collateral/MachineryAssetPageForm";
import CommodityAssetPageList from "./components/pages/collateral/CommodityAssetPageList";
import CommodityAssetPageForm from "./components/pages/collateral/CommodityAssetPageForm";
import InventoryAssetPageList from "./components/pages/collateral/InventoryAssetPageList";
import InventoryAssetPageForm from "./components/pages/collateral/InventoryAssetPageForm";
import ObligationPageList from "./components/pages/collateral/ObligationPageList";
import ProductPageList from "./components/pages/deals/ProductPageList";
import DealPageList from "./components/pages/deals/DealPageList";
import ProductCatalogPageForm from "./components/pages/deals/ProductCatalogPageForm";
import VerificationConfigPageList from "./components/pages/collateral/VerificationConfigPageList";
import LegalCasePageList from "./components/pages/recovery/LegalCasePageList";
import LegalCasePageForm from "./components/pages/recovery/LegalCasePageForm";
import LegalCasePageEdit from "./components/pages/recovery/LegalCasePageEdit";
import LegalCasePageDetail from "./components/pages/recovery/LegalCasePageDetail";
import BeneficiaryPageList from "./components/pages/recovery/BeneficiaryPageList";
import ExpensePageList from "./components/pages/recovery/ExpensePageList";
import Cpc25ReportPage from "./components/pages/recovery/Cpc25ReportPage";
import VerificationConfigPageEdit from "./components/pages/collateral/VerificationConfigPageEdit";
import VerificationConfigPageView from "./components/pages/collateral/VerificationConfigPageView";
import DraweeConfirmationPageView from "./components/pages/collateral/DraweeConfirmationPageView";
import SignaturePageList from "./components/pages/signature/SignaturePageList";
import IssuanceListPage from "./components/pages/funding/IssuanceListPage";
import IssuanceFormPage from "./components/pages/funding/IssuanceFormPage";
import PlatformListPage from "./components/pages/funding/PlatformListPage";
import ContractCreatePage from "./components/pages/contract/ContractCreatePage";
import ContractSignPage from "./components/pages/contract/ContractSignPage";
import ContractTypeListPage from "./components/pages/contract/ContractTypeListPage";
import ContractTypeStructureForm from "./components/pages/contract/ContractTypeStructureForm";
import SendToSignatureModalRoute from "./components/pages/signature/SendToSignatureModalRoute";
import SignatureDetailPage from "./components/pages/signature/SignatureDetailPage";

import BillerListBills from "./components/pages/financial/BillerListBills";
import BillerCreateBill from "./components/pages/financial/BillerCreateBill";
import BillerBatchCreateBill from "./components/pages/financial/BillerBatchCreateBill";
import LiquidationsList from "./components/pages/financial/LiquidationsList";
import DimensaLoteList from "./components/pages/financial/DimensaLoteList";
import ChargesPage from "./components/pages/billing/ChargesPage";
import CreditOperationsPage from "./components/pages/settlement/CreditOperationsPage";
import InvoicesPage from "./components/pages/billing/InvoicesPage";
import ReceivingBankAccountPageList from "./components/pages/billing/ReceivingBankAccountPageList";
import OperationTitleDebtsPage from "./components/pages/settlement/OperationTitleDebtsPage";
import RegisterPaymentPage from "./components/pages/billing/RegisterPaymentPage";
import PaymentIdentificationPage from "./components/pages/billing/PaymentIdentificationPage";
import PaymentsPage from "./components/pages/billing/PaymentsPage";
import BusinessPropertiesPage from "./components/pages/billing/BusinessPropertiesPage";


const Cities = lazy(() => import('./components/pages/geo-location/Cities'));
const Provinces = lazy(() => import('./components/pages/geo-location/Provinces'));
const HectarePrices = lazy(() => import('./components/pages/geo-location/HectarePrices'));


const StoragePageList = lazy(() => import('./components/pages/barn/StoragePageList'));
const CustodyTitlePageList = lazy(() => import('./components/pages/b3-custody/CustodyTitlePageList'));
const CustodyOperationPageList = lazy(() => import('./components/pages/b3-custody/CustodyOperationPageList'));
const CustodyRegistrationPageList = lazy(() => import('./components/pages/b3-custody/CustodyRegistrationPageList'));
const CustodyConfigurationPage = lazy(() => import('./components/pages/b3-custody/CustodyConfigurationPage'));
const CustodyProductView = lazy(() => import('./components/pages/b3-custody/CustodyProductView'));
const CommodityRouteDrawer = lazy(() => import('./components/pages/b3-custody/shared/CommodityRouteDrawer'));
const IssuerRouteDrawer = lazy(() => import('./components/pages/b3-custody/shared/IssuerRouteDrawer'));
const CprInstrumentDetailRouteDrawer = lazy(() => import('./components/pages/b3-custody/shared/CprInstrumentDetailRouteDrawer'));
const CprInstrumentPayloadRouteDrawer = lazy(() => import('./components/pages/b3-custody/shared/CprInstrumentPayloadRouteDrawer'));
const CprAttemptsRouteDrawer = lazy(() => import('./components/pages/b3-custody/shared/CprAttemptsRouteDrawer'));
const CprRemittancesRouteDrawer = lazy(() => import('./components/pages/b3-custody/shared/CprRemittancesRouteDrawer'));
const CprGuarantorsRouteDrawer = lazy(() => import('./components/pages/b3-custody/shared/CprGuarantorsRouteDrawer'));
const LcaCreditRightDetailRouteDrawer = lazy(() => import('./components/pages/b3-custody/shared/LcaCreditRightDetailRouteDrawer'));
const LcaAttemptsRouteDrawer = lazy(() => import('./components/pages/b3-custody/shared/LcaAttemptsRouteDrawer'));
const RemittancePageList = lazy(() => import('./components/pages/b3-custody/RemittancePageList'));
const CprInstrumentPageList = lazy(() => import('./components/pages/b3-custody/CprInstrumentPageList'));
const FundingIssuancePageList = lazy(() => import('./components/pages/b3-custody/FundingIssuancePageList'));
const FundingIssuanceDetailRouteDrawer = lazy(() => import('./components/pages/b3-custody/shared/FundingIssuanceDetailRouteDrawer'));
const SpacePageList = lazy(() => import('./components/pages/barn/SpacePageList'));


const AppRoutes = () => {

    // Perfis vêm de services/Auth/roles para que as telas possam gatear ações internas com
    // as mesmas constantes que as rotas usam (AF-3649). COMMERCIAL_MANAGER existe em ROLES
    // mas ainda não é usado em nenhuma rota.
    const {
        ADMIN, OPERATOR, LEGAL, CREDIT_ANALYST, CREDIT_MANAGER, FINANCIAL,
        CONTRACT_OPERATIONS_ANALYST, INDIVIDUAL_REGISTRATION, COLLECTION_ANALYST,
        BLOCKLIST, MLP_ANALYST, FUNDING_MANAGER,
        B3_CUSTODY_ADMIN, B3_CUSTODY_CREDIT_OPERATOR, B3_CUSTODY_FUNDING_OPERATOR,
    } = ROLES;

    // Conjuntos de acesso da Custódia B3 por tela (AF-3830). O backend expõe
    // b3-custody como rota única; a granularidade por tela vive aqui.
    const B3_CONFIG_ROLES = [ADMIN, B3_CUSTODY_ADMIN];
    const B3_CUSTODY_SCREEN_ROLES = [ADMIN, B3_CUSTODY_ADMIN, B3_CUSTODY_CREDIT_OPERATOR];
    const B3_REMITTANCE_ROLES = [ADMIN, B3_CUSTODY_ADMIN, B3_CUSTODY_CREDIT_OPERATOR, B3_CUSTODY_FUNDING_OPERATOR];
    const B3_FUNDING_ROLES = [ADMIN, FUNDING_MANAGER, B3_CUSTODY_ADMIN, B3_CUSTODY_FUNDING_OPERATOR];


    return (
        <HashRouter>
            <Routes>
                <Route path="/" element={<App />} errorElement={<InternalError />}>
                    <Route path="home" element={<RequireAuth roles={[ADMIN, OPERATOR, LEGAL, CREDIT_ANALYST, CREDIT_MANAGER]}><Home /></RequireAuth>} />
                    <Route path="chat" element={<RequireAuth roles={[ADMIN, OPERATOR, LEGAL, CREDIT_ANALYST, CREDIT_MANAGER]}><Chat /></RequireAuth>} />
                    <Route path="person/partners/:page/:pageSize/:field/:order/:filter?" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <LegalPersonPageList />
                        </RequireAuth>
                    }>
                        <Route
                            path="profiles/:personId"
                            element={<SelectProfilesModal />}
                        />
                    </Route>

                    <Route path="person/partners/form" element={
                        <RequireAuth roles={[ADMIN, INDIVIDUAL_REGISTRATION]}>
                            <LegalPersonPageForm />
                        </RequireAuth>
                    } />

                    <Route path="person/partners/edit/:personId" element={
                        <RequireAuth roles={[ADMIN, INDIVIDUAL_REGISTRATION, LEGAL, OPERATOR]}>
                            <LegalPersonPageEdit />
                        </RequireAuth>
                    } />

                    <Route path="person/signatories" element={
                        <RequireAuth roles={[ADMIN, LEGAL, OPERATOR]}>
                            <SignatoryListPage />
                        </RequireAuth>
                    } />


                    <Route path="referrals/partner-analysis/:analysisType/:referralId" element={
                        <RequireAuth roles={[ADMIN, CREDIT_MANAGER, CREDIT_ANALYST]}>
                            <CreditLimitAnalysisForm />
                        </RequireAuth>
                    } />

                    <Route path="referrals/partner-analysis/:page/:pageSize/:field/:order/:filter?"
                        element={<RequireAuth roles={[ADMIN, CREDIT_ANALYST, CREDIT_MANAGER]}><ReferralPartnerAnalysisListPage /></RequireAuth>}>
                        <Route
                            path="agrolend-score/:referralId"
                            element={<ScoreAgrolendModal />}
                        />
                        <Route
                            path="biro-list/:referralId/:partnerId"
                            element={<BiroListModal />}
                        />
                        <Route
                            path="biro-variables/:referralId/:providerName"
                            element={<BiroVariablesModal />}
                        />
                        <Route
                            path="biro-document/:referralId/:providerName"
                            element={<BiroDocumentModal />}
                        />
                        <Route
                            path="referral-detail/:referralId"
                            element={<ReferralDetailModal />}
                        />
                    </Route>

                    <Route path="referrals/loan-order-analysis/:analysisType/:referralId" element={
                        <RequireAuth roles={[ADMIN, CREDIT_MANAGER, CREDIT_ANALYST]}>
                            <LoanOrderAnalysisForm />
                        </RequireAuth>
                    } />

                    <Route path="referrals/loan-order-analysis/rejected/:page/:pageSize/:field/:order/:filter?" element={
                        <RequireAuth roles={[ADMIN, CREDIT_MANAGER, CREDIT_ANALYST]}>
                            <ReferralLoanOrderRejectedListPage />
                        </RequireAuth>
                    } />

                    <Route path="farmers/view/:loanOrderId" element={
                        <RequireAuth roles={[ADMIN, CREDIT_MANAGER, CREDIT_ANALYST]}>
                            <FarmerDataViewPage />
                        </RequireAuth>
                    }>
                        <Route
                            path="biro-list/:referralId/:partnerId"
                            element={<BiroListModal />}
                        />
                        <Route
                            path="biro-variables/:referralId/:providerName"
                            element={<BiroVariablesModal />}
                        />
                        <Route
                            path="biro-document/:referralId/:providerName"
                            element={<BiroDocumentModal />}
                        />
                        <Route
                            path="referral-detail/:referralId"
                            element={<ReferralDetailModal />}
                        />
                    </Route>

                    <Route path="referrals/loan-order-analysis/:page/:pageSize/:field/:order/:filter?" element={
                        <RequireAuth roles={[ADMIN, CONTRACT_OPERATIONS_ANALYST]}>
                            <LoanOrderAnalysisListPage />
                        </RequireAuth>
                    } />

                    <Route path="referrals/farmer-analysis/:page/:pageSize/:field/:order/:filter?"
                        element={<RequireAuth roles={[ADMIN, CREDIT_MANAGER]}><FarmerOrderListPage /></RequireAuth>}>
                        <Route
                            path="agrolend-score/:referralId"
                            element={<ScoreAgrolendModal />}
                        />
                        <Route
                            path="biro-list/:referralId/:partnerId"
                            element={<BiroListModal />}
                        />
                        <Route
                            path="biro-variables/:referralId/:providerName"
                            element={<BiroVariablesModal />}
                        />
                        <Route
                            path="biro-document/:referralId/:providerName"
                            element={<BiroDocumentModal />}
                        />
                        <Route
                            path="referral-detail/:referralId"
                            element={<ReferralDetailModal />}
                        />
                    </Route>

                    <Route path="referrals/partner-analyzed/:page/:pageSize/:field/:order/:filter?"
                        element={<RequireAuth roles={[ADMIN, CREDIT_ANALYST, CREDIT_MANAGER]}><ReferralPartnerAnalyzedListPage /></RequireAuth>}>
                        <Route
                            path="agrolend-score/:referralId"
                            element={<ScoreAgrolendModal />}
                        />
                        <Route
                            path="biro-list/:referralId/:partnerId"
                            element={<BiroListModal />}
                        />
                        <Route
                            path="biro-variables/:referralId/:providerName"
                            element={<BiroVariablesModal />}
                        />
                        <Route
                            path="biro-document/:referralId/:providerName"
                            element={<BiroDocumentModal />}
                        />
                        <Route
                            path="referral-detail/:referralId"
                            element={<ReferralDetailModal />}
                        />
                    </Route>

                    <Route path="analysis/batch-analysis/:page/:pageSize/:field/:order/:filter?"
                        element={
                            <RequireAuth roles={[ADMIN, OPERATOR]}>
                                <BatchAnalysisListPage />
                            </RequireAuth>
                        } />

                    <Route path="analysis/batch-analysis/form" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <BatchAnalysisFormPage />
                        </RequireAuth>
                    } />

                    <Route path="analysis/batch-analysis/view/:id" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <BatchAnalysisView />
                        </RequireAuth>
                    } />

                    <Route path="cities" element={
                        <RequireAuth roles={[ADMIN, CREDIT_ANALYST, CREDIT_MANAGER]}>
                            <Suspense fallback={<Loading />}>
                                <Cities />
                            </Suspense>
                        </RequireAuth>
                    } />

                    <Route path="provinces" element={
                        <RequireAuth roles={[ADMIN, CREDIT_ANALYST, CREDIT_MANAGER]}>
                            <Suspense fallback={<Loading />}>
                                <Provinces />
                            </Suspense>
                        </RequireAuth>}
                    />

                    <Route path="hectare-prices" element={
                        <RequireAuth roles={[ADMIN, CREDIT_ANALYST, CREDIT_MANAGER]}>
                            <Suspense fallback={<Loading />}>
                                <HectarePrices />
                            </Suspense>
                        </RequireAuth>}
                    />

                    <Route path="commercial/:page/:pageSize/:field/:order/:filter?" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <CommercialPage />
                        </RequireAuth>
                    } />

                    <Route
                        path="commercial-association"
                        element={
                            <RequireAuth roles={[ADMIN, OPERATOR]}>
                                <CommercialFormPage />
                            </RequireAuth>
                        }
                    />

                    <Route path="referrals/reasons/:page/:pageSize/:field/:order/:filter?"
                        element={
                            <RequireAuth roles={[ADMIN, CREDIT_MANAGER]}>
                                <ReasonPageList />
                            </RequireAuth>
                        }
                    >
                        <Route
                            path="form"
                            element={<ReasonFormModal />}
                        />
                    </Route>

                    <Route path="referrals/configuration"
                        element={
                            <RequireAuth roles={[ADMIN, CREDIT_MANAGER]}>
                                <ReferralConfiguration />
                            </RequireAuth>
                        }
                    />

                    <Route path="referrals/linkwithreferral/:loanOrderUUID"
                        element={
                            <RequireAuth roles={[ADMIN, CREDIT_MANAGER]}>
                                <LinkUpReferralWithLoanOrderFormPage />
                            </RequireAuth>
                        }
                    />

                    <Route path="referrals/list-unlinked-order/:page/:pageSize/:field/:order/:filter?"
                        element={
                            <RequireAuth roles={[ADMIN, CREDIT_MANAGER]}>
                                <FarmerOrderUnlinkedListPage />
                            </RequireAuth>
                        }
                    />

                    <Route path="loan/form/:referralId" element={
                        <RequireAuth roles={[ADMIN, LEGAL]}>
                            <LoanFormPage />
                        </RequireAuth>
                    } />

                    <Route path="loan-order/farmer-list/:page/:pageSize/:field/:order/:filter?"
                        element={
                            <RequireAuth roles={[ADMIN, INDIVIDUAL_REGISTRATION]}>
                                <FarmerPageList />
                            </RequireAuth>
                        }
                    />

                    <Route path="individual/individual-list/:page/:pageSize/:field/:order/:filter?" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <IndividualPageList />
                        </RequireAuth>
                    }>
                        <Route
                            path="profiles/:personId"
                            element={<SelectProfilesModal />}
                        />
                    </Route>

                    <Route path="person/individual/form" element={
                        <RequireAuth roles={[ADMIN, INDIVIDUAL_REGISTRATION]}>
                            <IndividualPageForm />
                        </RequireAuth>
                    }>
                    </Route>

                    <Route path="person/individual/edit/:personId" element={
                        <RequireAuth roles={[ADMIN, INDIVIDUAL_REGISTRATION, LEGAL, OPERATOR]}>
                            <IndividualPageEdit />
                        </RequireAuth>
                    } />



                    <Route
                        path="feature-flags/referral/:page/:pageSize/:field/:order/:filter?"
                        element={
                            <RequireAuth roles={[ADMIN]}>
                                <FeatureFlagReferral />
                            </RequireAuth>
                        }
                    />

                    <Route
                        path="feature-flags/referral/view/:id"
                        element={
                            <RequireAuth roles={[ADMIN]}>
                                <FeatureFlagReferralView />
                            </RequireAuth>
                        }
                    />

                    <Route
                        path="billing/business-properties"
                        element={
                            <RequireAuth roles={[ADMIN]}>
                                <BusinessPropertiesPage />
                            </RequireAuth>
                        }
                    />

                    <Route path="communication/notifications/:filter?"
                        element={
                            <RequireAuth roles={[ADMIN, COLLECTION_ANALYST]}>
                                <NotificationPageList />
                            </RequireAuth>
                        }
                    >
                        <Route path="messages/:notificationId" element={<div />} />
                        <Route path="messages/:notificationId/:messageId" element={<div />} />
                    </Route>

                    <Route path="communication/calendar/:scheduledType/:year/:month"
                        element={<RequireAuth roles={[ADMIN, COLLECTION_ANALYST]}>
                            <NotificationCalendarPage />
                        </RequireAuth>}
                    />

                    <Route path="communication/batch-form/:scheduledType/:targetDate"
                        element={<RequireAuth roles={[ADMIN, COLLECTION_ANALYST]}>
                            <BatchNotificationForm />
                        </RequireAuth>}
                    />

                    <Route path="communication/message-compositions/:page/:pageSize/:field/:order/:filter?"
                        element={<RequireAuth roles={[ADMIN, COLLECTION_ANALYST]}>
                            <MessageCompositionPageList />
                        </RequireAuth>}
                    />

                    <Route path="communication/message-composition/new"
                        element={<RequireAuth roles={[ADMIN, COLLECTION_ANALYST]}>
                            <MessageCompositionStudioPage mode="new" />
                        </RequireAuth>}
                    >
                        <Route path="group/new" element={<GroupNewDrawerRoute />} />
                    </Route>

                    <Route path="communication/message-composition/:id/edit/:section?"
                        element={<RequireAuth roles={[ADMIN, COLLECTION_ANALYST]}>
                            <MessageCompositionStudioPage mode="edit" />
                        </RequireAuth>}
                    >
                        <Route path="group/new" element={<GroupNewDrawerRoute />} />
                    </Route>

                    <Route path="communication/message-composition/:id/:section?"
                        element={<RequireAuth roles={[ADMIN, COLLECTION_ANALYST]}>
                            <MessageCompositionStudioPage mode="view" />
                        </RequireAuth>}
                    >
                        <Route path="group/new" element={<GroupNewDrawerRoute />} />
                    </Route>

                    <Route path="communication/templates/:page/:pageSize/:field/:order"
                        element={<RequireAuth roles={[ADMIN, COLLECTION_ANALYST]}>
                            <TemplatePageList />
                        </RequireAuth>}
                    />

                    <Route path="communication/templates/new"
                        element={<RequireAuth roles={[ADMIN, COLLECTION_ANALYST]}>
                            <TemplateStudioPage mode="new" />
                        </RequireAuth>}
                    />

                    <Route path="communication/templates/item/:id/edit"
                        element={<RequireAuth roles={[ADMIN, COLLECTION_ANALYST]}>
                            <TemplateStudioPage mode="edit" />
                        </RequireAuth>}
                    />

                    <Route path="communication/templates/item/:id"
                        element={<RequireAuth roles={[ADMIN, COLLECTION_ANALYST]}>
                            <TemplateStudioPage mode="view" />
                        </RequireAuth>}
                    />

                    <Route path="communication/groups/:page/:pageSize/:field/:order/:filter?"
                        element={<RequireAuth roles={[ADMIN, COLLECTION_ANALYST]}>
                            <GroupPageList />
                        </RequireAuth>}
                    >
                        <Route path="new" element={<GroupNewDrawerRoute />} />
                        <Route path="item/:id" element={<GroupDrawerRoute />} />
                        <Route path="item/:id/edit" element={<GroupDrawerRoute />} />
                    </Route>

                    <Route path="communication/routings"
                        element={<RequireAuth roles={[ADMIN, COLLECTION_ANALYST]}>
                            <RoutingPageList />
                        </RequireAuth>}
                    />

                    <Route path="communication/routing/:id"
                        element={<RequireAuth roles={[ADMIN, COLLECTION_ANALYST]}>
                            <RoutingViewPage />
                        </RequireAuth>}
                    />

                    <Route path="communication/configuration"
                        element={
                            <RequireAuth roles={[ADMIN]}>
                                <CommunicationConfiguration />
                            </RequireAuth>
                        }
                    />

                    <Route path="communication/contact/:page/:pageSize/:field/:order/:filter?"
                        element={
                            <RequireAuth roles={[ADMIN, COLLECTION_ANALYST]}>
                                <ContactPageList />
                            </RequireAuth>
                        }
                    />

                    <Route path="communication/contact/:id/page-view"
                        element={
                            <RequireAuth roles={[ADMIN, COLLECTION_ANALYST]}>
                                <ContactPageView />
                            </RequireAuth>
                        }
                    >
                        <Route path="tab/:tab" />
                        <Route path="channel/:channelType/:channelId?" element={<ContactPointModalFormRoute />} />
                        <Route path="edit" element={<ContactModalEditRoute />} />
                        <Route path="call" element={<CallRegistryModalFormRoute />} />
                    </Route>

                    <Route path="users" element={<RequireAuth roles={[ADMIN]}><UserPageList /></RequireAuth>}>
                        <Route path=":userId" element={<UserPageView />} />
                    </Route>

                    <Route
                        path="funding/issuance/list"
                        element={
                            <RequireAuth roles={B3_FUNDING_ROLES}>
                                <IssuanceListPage />
                            </RequireAuth>
                        }
                    />

                    <Route
                        path="funding/issuance/form"
                        element={
                            <RequireAuth roles={B3_FUNDING_ROLES}>
                                <IssuanceFormPage />
                            </RequireAuth>
                        }
                    />

                    <Route
                        path="funding/platform/list"
                        element={
                            <RequireAuth roles={B3_FUNDING_ROLES}>
                                <PlatformListPage />
                            </RequireAuth>
                        }
                    />

                    <Route
                        path="financial/disbursement-list"
                        element={
                            <RequireAuth roles={[ADMIN, FINANCIAL]}>
                                <ContractDisbursementList />
                            </RequireAuth>
                        }
                    />

                    <Route
                        path="financial/liquidations-list"
                        element={
                            <RequireAuth roles={[ADMIN, FINANCIAL]}>
                                <LiquidationsList />
                            </RequireAuth>
                        }
                    />

                    <Route
                        path="/financial/dimensa-lote-list"
                        element={
                            <RequireAuth roles={[ADMIN, FINANCIAL]}>
                                <DimensaLoteList />
                            </RequireAuth>
                        }
                    />

                    <Route
                        path="billing/charges"
                        element={
                            <RequireAuth roles={[ADMIN, FINANCIAL, COLLECTION_ANALYST]}>
                                <ChargesPage />
                            </RequireAuth>
                        }
                    />

                    <Route
                        path="billing/payment-identification"
                        element={
                            <RequireAuth roles={[ADMIN, FINANCIAL, COLLECTION_ANALYST]}>
                                <PaymentIdentificationPage />
                            </RequireAuth>
                        }
                    />

                    {/* DEPRECATED — o ato de pagar em UM passo (registra, identifica e liquida de
                        uma vez, sem conferência no meio). Fora do menu, mas a rota FICA: se a
                        operação decidir voltar ao fluxo único, voltar é trocar o item do menu, não
                        reescrever a tela. Não aponte nada novo para cá. */}
                    <Route
                        path="billing/register-payment"
                        element={
                            <RequireAuth roles={[ADMIN, FINANCIAL, COLLECTION_ANALYST]}>
                                <RegisterPaymentPage />
                            </RequireAuth>
                        }
                    />

                    <Route
                        path="billing/payments"
                        element={
                            <RequireAuth roles={[ADMIN, FINANCIAL, COLLECTION_ANALYST]}>
                                <PaymentsPage />
                            </RequireAuth>
                        }
                    />

                    <Route
                        path="billing/invoices"
                        element={
                            <RequireAuth roles={[ADMIN, FINANCIAL, COLLECTION_ANALYST]}>
                                <InvoicesPage />
                            </RequireAuth>
                        }
                    />

                    <Route
                        path="billing/receiving-bank-accounts"
                        element={
                            <RequireAuth roles={[ADMIN, FINANCIAL, COLLECTION_ANALYST]}>
                                <ReceivingBankAccountPageList />
                            </RequireAuth>
                        }
                    />

                    <Route
                        path="settlement/operations"
                        element={
                            <RequireAuth roles={[ADMIN, FINANCIAL, COLLECTION_ANALYST]}>
                                <CreditOperationsPage />
                            </RequireAuth>
                        }
                    />

                    <Route
                        path="settlement/operations/:contractOperationId"
                        element={
                            <RequireAuth roles={[ADMIN, FINANCIAL, COLLECTION_ANALYST]}>
                                <OperationTitleDebtsPage />
                            </RequireAuth>
                        }
                    />

                    <Route
                        path="financial/biller"
                        element={
                            <RequireAuth roles={[ADMIN/*, FINANCIAL*/]}>
                                <BillerListBills />
                            </RequireAuth>
                        }
                    />

                    <Route
                        path="financial/biller/create"
                        element={
                            <RequireAuth roles={[ADMIN/*, FINANCIAL*/]}>
                                <BillerCreateBill />
                            </RequireAuth>
                        }
                    />

                    <Route
                        path="financial/biller/batch-create"
                        element={
                            <RequireAuth roles={[ADMIN/*, FINANCIAL*/]}>
                                <BillerBatchCreateBill />
                            </RequireAuth>
                        }
                    />

                    <Route path="/blocklist/:page/:pageSize/:field/:order/:filter?"
                        element={
                            <RequireAuth roles={[ADMIN, BLOCKLIST]}>
                                <BlockListPage />
                            </RequireAuth>
                        } />

                    <Route path="blocklist/file-input/form" element={
                        <RequireAuth roles={[ADMIN, BLOCKLIST]}>
                            <BlockListInputForm />
                        </RequireAuth>
                    } />
                    <Route path="blocklist/changed" element={
                        <RequireAuth roles={[ADMIN, BLOCKLIST]}>
                            <BlockListChanged />
                        </RequireAuth>
                    } />
                    <Route path="data-provider/batch-report/:page/:pageSize/:field/:order/:filter?" element={
                        <RequireAuth roles={[ADMIN, CREDIT_ANALYST, CREDIT_MANAGER]}>
                            <BatchReportPageList />
                        </RequireAuth>
                    } />
                    <Route path="data-provider/batch-report/form" element={
                        <RequireAuth roles={[ADMIN, CREDIT_ANALYST, CREDIT_MANAGER]}>
                            <BatchReportPageForm />
                        </RequireAuth>
                    } />
                    <Route path="data-provider/batch-report/view/:id/report/:document" element={
                        <RequireAuth roles={[ADMIN, CREDIT_ANALYST, CREDIT_MANAGER]}>
                            <ReportPageView />
                        </RequireAuth>
                    } />
                    <Route path="data-provider/batch-report/view/:id/:page?/:pageSize?/:field?/:order?" element={
                        <RequireAuth roles={[ADMIN, CREDIT_ANALYST, CREDIT_MANAGER]}>
                            <BatchReportPageView />
                        </RequireAuth>
                    } />
                    <Route path="sicor/report/:page/:pageSize/:field/:order/:filter?" element={
                        <RequireAuth roles={[ADMIN, CREDIT_ANALYST, CREDIT_MANAGER]}>
                            <SicorReportPageList />
                        </RequireAuth>
                    } />
                    <Route path="sicor/document/:document/:page/:pageSize/:field/:order" element={
                        <RequireAuth roles={[ADMIN, CREDIT_ANALYST, CREDIT_MANAGER]}>
                            <SicorDocumentPageList />
                        </RequireAuth>
                    } />
                    <Route path="sicor/document/:document/:bacenId" element={
                        <RequireAuth roles={[ADMIN, CREDIT_ANALYST, CREDIT_MANAGER]}>
                            <SicorDocumentPageView />
                        </RequireAuth>
                    } />
                    <Route path="data-provider/report-type/:page/:pageSize/:field/:order/:filter?" element={
                        <RequireAuth roles={[ADMIN, CREDIT_ANALYST, CREDIT_MANAGER]}>
                            <ReportTypePageList />
                        </RequireAuth>
                    } />
                    <Route path="data-provider/report-type/view/:id" element={
                        <RequireAuth roles={[ADMIN, CREDIT_ANALYST, CREDIT_MANAGER]}>
                            <ReportTypePageView />
                        </RequireAuth>
                    } />
                    <Route path="data-provider/report-type/edit/:id" element={
                        <RequireAuth roles={[ADMIN, CREDIT_ANALYST, CREDIT_MANAGER]}>
                            <ReportTypePageForm />
                        </RequireAuth>
                    } />
                    <Route path="data-provider/annual-provider-reports/:page/:pageSize/:field/:order/:filter?" element={
                        <RequireAuth roles={[ADMIN, CREDIT_ANALYST, CREDIT_MANAGER]}>
                            <AnnualProviderReportPageList />
                        </RequireAuth>
                    } />
                    <Route path="recommendation-engine/parecer/:page/:pageSize/:field/:order/:filter?" element={
                        <RequireAuth roles={[ADMIN, MLP_ANALYST]}>
                            <RecommendationEngineParecerView />
                        </RequireAuth>
                    } />
                    <Route path="recommendation-engine/parecer-view/:batchSk?" element={
                        <RequireAuth roles={[ADMIN, MLP_ANALYST]}>
                            <RecommendationEngineParecerView />
                        </RequireAuth>
                    } />
                    <Route path="recommendation-engine/provider-documents/:batchId" element={
                        <RequireAuth roles={[ADMIN, MLP_ANALYST, CREDIT_MANAGER, CREDIT_ANALYST]}>
                            <ProviderDocumentsGrid />
                        </RequireAuth>
                    } />
                    <Route path="recommendation-engine/rules/:page/:pageSize/:field/:order/:filter?" element={
                        <RequireAuth roles={[ADMIN, MLP_ANALYST, CREDIT_MANAGER, CREDIT_ANALYST]}>
                            <RecommendationEngineRulesList />
                        </RequireAuth>
                    } />
                    <Route path="recommendation-engine/rule/view/:id" element={
                        <RequireAuth roles={[ADMIN, MLP_ANALYST, CREDIT_MANAGER, CREDIT_ANALYST]}>
                            <RecommendationEnginePageView />
                        </RequireAuth>
                    } />
                    <Route path="recommendation-engine/recommendations/:page/:pageSize/:field/:order/:filter?" element={
                        <RequireAuth roles={[ADMIN, MLP_ANALYST, CREDIT_MANAGER, CREDIT_ANALYST]}>
                            <RecommendationEngineRecommendationsList />
                        </RequireAuth>
                    } />
                    <Route path="recommendation-engine/recommendations/:id" element={
                        <RequireAuth roles={[ADMIN, MLP_ANALYST, CREDIT_MANAGER, CREDIT_ANALYST]}>
                            <RecommendationEngineRecommendationView />
                        </RequireAuth>
                    } />
                    <Route path="recommendation-engine/rule/form" element={
                        <RequireAuth roles={[ADMIN, MLP_ANALYST, CREDIT_MANAGER, CREDIT_ANALYST]}>
                            <RecommendationEnginePageForm />
                        </RequireAuth>
                    } />
                    <Route path="recommendation-engine/rule/edit/:id" element={
                        <RequireAuth roles={[ADMIN, MLP_ANALYST, CREDIT_MANAGER, CREDIT_ANALYST]}>
                            <RecommendationEnginePageForm />
                        </RequireAuth>
                    } />
                    {/* PLD Monitoring */}
                    <Route path="monitoring" element={
                        <RequireAuth roles={[ADMIN, MLP_ANALYST, CREDIT_MANAGER]}>
                            <MonitoringPage />
                        </RequireAuth>
                    } />

                    {/* LEGAL acessa esta lista em modo leitura (AF-3649): consegue enviar o
                        contrato para assinatura, mas não abre nem cria operações. As ações são
                        gateadas dentro da OperationsPage, já que RequireAuth é tudo-ou-nada. */}
                    <Route path="contracts/:page/:pageSize/:field/:order/:filter?" element={
                        <RequireAuth roles={[ADMIN, OPERATOR, LEGAL]}>
                            <OperationsPage />
                        </RequireAuth>
                    } />
                    <Route path="contracts/new" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <OperationReceivablesAssignmentFormPage />
                        </RequireAuth>
                    } />
                    <Route path="operations/receivables-assignment/:id" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <ReceivablesAssignmentPage />
                        </RequireAuth>
                    } />
                    <Route path="contracts/loan/new" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <OperationLoanFormPage />
                        </RequireAuth>
                    } />
                    <Route path="operations/structured-operation/:id" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <StructuredOperationPage />
                        </RequireAuth>
                    } />
                    <Route path="operations/acknowledgement-debt/:id" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <AcknowledgementDebtPage />
                        </RequireAuth>
                    } />
                    <Route path="operations/drawee-risk/new" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <CreateDraweeRiskPage />
                        </RequireAuth>
                    } />
                    <Route path="operations/drawee-risk/:id" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <DraweeRiskViewPage />
                        </RequireAuth>
                    } />
                    <Route path="operations/loan/:id" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <OperationLoanFormPage />
                        </RequireAuth>
                    } />
                    <Route path="structuring/operations/:page/:pageSize" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <OperationPageList />
                        </RequireAuth>
                    } />
                    <Route path="structuring/operation" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <OperationPageForm />
                        </RequireAuth>
                    } />
                    <Route path="structuring/operation/view/:id" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <OperationPageView />
                        </RequireAuth>
                    } />
                    <Route path="deals/:view" element={
                        <RequireAuth roles={[ADMIN, OPERATOR, CREDIT_MANAGER]}>
                            <DealPageList />
                        </RequireAuth>
                    } />
                    <Route path="deals/products" element={
                        <RequireAuth roles={[ADMIN, OPERATOR, CREDIT_MANAGER]}>
                            <ProductPageList />
                        </RequireAuth>
                    } />
                    <Route path="deals/product-catalog" element={
                        <RequireAuth roles={[ADMIN, OPERATOR, CREDIT_MANAGER]}>
                            <ProductCatalogPageForm />
                        </RequireAuth>
                    } />
                    <Route path="credit-analysis/:tab" element={
                        <RequireAuth roles={[ADMIN, CREDIT_ANALYST, CREDIT_MANAGER]}>
                            <CreditAnalysisMain />
                        </RequireAuth>
                    } />
                    <Route path="credit-analysis/batch/:batchId" element={
                        <RequireAuth roles={[ADMIN, CREDIT_ANALYST, CREDIT_MANAGER]}>
                            <BatchProcessingDetail />
                        </RequireAuth>
                    } />
                    <Route path="credit-analysis/batch/:batchId/analysis" element={
                        <RequireAuth roles={[ADMIN, CREDIT_ANALYST, CREDIT_MANAGER]}>
                            <CreditAnalysisBatchView />
                        </RequireAuth>
                    } />
                    <Route path="credit-analysis" element={
                        <RequireAuth roles={[ADMIN, CREDIT_ANALYST, CREDIT_MANAGER]}>
                            <CreditAnalysisMain />
                        </RequireAuth>
                    } />
                    <Route path="credit-analysis/form" element={
                        <RequireAuth roles={[ADMIN, CREDIT_ANALYST, CREDIT_MANAGER]}>
                            <CreditAnalysisPageForm />
                        </RequireAuth>
                    } />
                    {/* Gestão de Documentos (AF-4107) desativada — ver pages/document-management/README.md. */}
                    <Route path="collateral/verification-config" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <VerificationConfigPageList />
                        </RequireAuth>
                    }>
                    </Route>
                    <Route path="collateral/verification-config/:id/view" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <VerificationConfigPageView />
                        </RequireAuth>
                    } />
                    <Route path="collateral/verification-config/:id/view/edit" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <VerificationConfigPageEdit />
                        </RequireAuth>
                    } />
                    <Route path="collateral/drawee-confirmation" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <DraweeConfirmationPageList />
                        </RequireAuth>
                    }>
                    </Route>
                    <Route path="collateral/drawee-confirmation/:validationId/receivables" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <DraweeConfirmationPageView />
                        </RequireAuth>
                    } />
                    <Route path="collateral/drawee-confirmation/:validationId/receivables/drawee/:taxId" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <DraweeConfirmationPageView />
                        </RequireAuth>
                    } />
                    <Route path="collateral/receivables" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <ReceivablePageList />
                        </RequireAuth>
                    } />
                    <Route path="collateral/credit-rights" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <CreditRightPageList />
                        </RequireAuth>
                    } />
                    <Route path="collateral/credit-right-batches" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <CreditRightBatchPageList />
                        </RequireAuth>
                    } />
                    <Route path="collateral/credit-right-batches/:batchId" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <CreditRightBatchPageView />
                        </RequireAuth>
                    } />
                    <Route path="collateral/vehicles" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <VehicleAssetPageList />
                        </RequireAuth>
                    }>
                        <Route path="new" element={<VehicleAssetPageForm />} />
                    </Route>
                    <Route path="collateral/properties" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <PropertyAssetPageList />
                        </RequireAuth>
                    }>
                        <Route path="new" element={<PropertyAssetPageForm />} />
                    </Route>
                    <Route path="collateral/machineries" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <MachineryAssetPageList />
                        </RequireAuth>
                    }>
                        <Route path="new" element={<MachineryAssetPageForm />} />
                    </Route>
                    <Route path="collateral/commodities" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <CommodityAssetPageList />
                        </RequireAuth>
                    }>
                        <Route path="new" element={<CommodityAssetPageForm />} />
                    </Route>
                    <Route path="collateral/inventories" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <InventoryAssetPageList />
                        </RequireAuth>
                    }>
                        <Route path="new" element={<InventoryAssetPageForm />} />
                    </Route>
                    <Route path="collateral/obligations" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <ObligationPageList />
                        </RequireAuth>
                    } />
                    {/* Recovery */}
                    <Route path="recovery/legal-cases" element={
                        <RequireAuth roles={[ADMIN, LEGAL]}>
                            <LegalCasePageList />
                        </RequireAuth>
                    }>
                        <Route path="new" element={<LegalCasePageForm />} />
                    </Route>
                    <Route path="recovery/legal-cases/:id" element={
                        <RequireAuth roles={[ADMIN, LEGAL]}>
                            <LegalCasePageDetail />
                        </RequireAuth>
                    } />
                    <Route path="recovery/legal-cases/:id/edit" element={
                        <RequireAuth roles={[ADMIN, LEGAL]}>
                            <LegalCasePageEdit />
                        </RequireAuth>
                    } />
                    <Route path="recovery/beneficiaries" element={
                        <RequireAuth roles={[ADMIN, LEGAL]}>
                            <BeneficiaryPageList />
                        </RequireAuth>
                    } />
                    <Route path="recovery/expenses" element={
                        <RequireAuth roles={[ADMIN, LEGAL]}>
                            <ExpensePageList />
                        </RequireAuth>
                    } />
                    <Route path="recovery/cpc25-report" element={
                        <RequireAuth roles={[ADMIN, LEGAL]}>
                            <Cpc25ReportPage />
                        </RequireAuth>
                    } />
                    {/* Deals */}
                    <Route path="deals/products" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <ProductPageList />
                        </RequireAuth>
                    } />
                    <Route path="deals/:view?" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <DealPageList />
                        </RequireAuth>
                    } />
                    {/* Signature */}
                    <Route path="signature" element={
                        <RequireAuth roles={[ADMIN, LEGAL]}>
                            <SignaturePageList />
                        </RequireAuth>
                    } />
                    <Route path="contract-types" element={
                        <RequireAuth roles={[ADMIN, OPERATOR, LEGAL]}>
                            <ContractTypeListPage />
                        </RequireAuth>
                    } />
                    <Route path="contract-types/:name" element={
                        <RequireAuth roles={[ADMIN, OPERATOR, LEGAL]}>
                            <ContractTypeStructureForm />
                        </RequireAuth>
                    } />
                    <Route path="contract/create" element={
                        <RequireAuth roles={[ADMIN, LEGAL]}>
                            <ContractCreatePage />
                        </RequireAuth>
                    }>
                        <Route path="send" element={<SendToSignatureModalRoute />} />
                    </Route>
                    <Route path="contracts/:operationId/sign" element={
                        <RequireAuth roles={[ADMIN, LEGAL, OPERATOR]}>
                            <ContractSignPage />
                        </RequireAuth>
                    } />
                    <Route path="signature/:id" element={
                        <RequireAuth roles={[ADMIN, LEGAL]}>
                            <SignatureDetailPage />
                        </RequireAuth>
                    } />
                    <Route path="maintenance" element={<RequireAuth roles={[ADMIN]}><MaintenanceFormPage /></RequireAuth>} />
                    <Route path="ti/software-portfolio/:page/:pageSize/:field/:order/:filter?" element={
                        <RequireAuth roles={[ADMIN]}>
                            <SoftwarePortfolioPageList />
                        </RequireAuth>
                    } />
                    <Route path="legal/files/:page/:pageSize/:field/:order/:filter?" element={
                        <RequireAuth roles={[ADMIN, LEGAL]}>
                            <FilePageList />
                        </RequireAuth>
                    } />
                    <Route path="legal/credit-operations/:page/:pageSize/:field/:order/:filter?" element={
                        <RequireAuth roles={[ADMIN, LEGAL]}>
                            <CreditOperationPageList />
                        </RequireAuth>
                    } />
                    <Route path="legal/files/:fileId/link" element={
                        <RequireAuth roles={[ADMIN, LEGAL]}>
                            <FileLinkModalForm />
                        </RequireAuth>
                    } />
                    <Route path="ti/software-analysis" element={
                        <RequireAuth roles={[ADMIN]}>
                            <SoftwareAnalysisPageView />
                        </RequireAuth>
                    } />
                    <Route path="ti/software-analysis/:software" element={
                        <RequireAuth roles={[ADMIN]}>
                            <SoftwareAnalysisDetailPageView />
                        </RequireAuth>
                    } />
                    <Route path="ti/event-platform/:tab?" element={
                        <RequireAuth roles={[ADMIN]}>
                            <EventPlatformPageView />
                        </RequireAuth>
                    } />
                    <Route path="/denied" element={<AccessDenied />} />
                    {/* Barn - Storage pages */}
                    <Route path="barn/files" element={
                        <RequireAuth roles={[ADMIN]}>
                            <Suspense fallback={<Loading />}>
                                <StoragePageList />
                            </Suspense>
                        </RequireAuth>}
                    />
                    <Route path="barn/spaces/:page/:pageSize/:field/:order/:filter?" element={
                        <RequireAuth roles={[ADMIN]}>
                            <Suspense fallback={<Loading />}>
                                <SpacePageList />
                            </Suspense>
                        </RequireAuth>}
                    />
                    <Route path="barn/spaces" element={
                        <RequireAuth roles={[ADMIN]}>
                            <Suspense fallback={<Loading />}>
                                <SpacePageList />
                            </Suspense>
                        </RequireAuth>}
                    />
                    <Route path="/error" element={<InternalError />} />
                    {/* B3 Custody pages */}
                    <Route path="b3-custody/titles/:page/:pageSize/:field/:order/:filter?" element={
                        <RequireAuth roles={B3_CUSTODY_SCREEN_ROLES}>
                            <Suspense fallback={<Loading />}>
                                <CustodyTitlePageList />
                            </Suspense>
                        </RequireAuth>}
                    />
                    <Route path="b3-custody/titles" element={
                        <RequireAuth roles={B3_CUSTODY_SCREEN_ROLES}>
                            <Suspense fallback={<Loading />}>
                                <CustodyTitlePageList />
                            </Suspense>
                        </RequireAuth>}
                    />
                    {/* B3 Custody - Operations */}
                    <Route path="b3-custody/operations/:page/:pageSize/:field/:order/:filter?" element={
                        <RequireAuth roles={B3_CUSTODY_SCREEN_ROLES}>
                            <Suspense fallback={<Loading />}>
                                <CustodyOperationPageList />
                            </Suspense>
                        </RequireAuth>}
                    />
                    <Route path="b3-custody/operations" element={
                        <RequireAuth roles={B3_CUSTODY_SCREEN_ROLES}>
                            <Suspense fallback={<Loading />}>
                                <CustodyOperationPageList />
                            </Suspense>
                        </RequireAuth>}
                    />
                    {/* B3 Custody - LCA Credit Rights */}
                    <Route path="b3-custody/lca-credit-rights/:page/:pageSize/:field/:order/:filter?" element={
                        <RequireAuth roles={B3_CUSTODY_SCREEN_ROLES}>
                            <Suspense fallback={<Loading />}>
                                <CustodyRegistrationPageList />
                            </Suspense>
                        </RequireAuth>}
                    >
                        <Route path="detail/:id" element={
                            <RequireAuth roles={B3_CUSTODY_SCREEN_ROLES}>
                                <Suspense fallback={<Loading />}>
                                    <LcaCreditRightDetailRouteDrawer />
                                </Suspense>
                            </RequireAuth>}
                        />
                        <Route path="attempts/:id" element={
                            <RequireAuth roles={B3_CUSTODY_SCREEN_ROLES}>
                                <Suspense fallback={<Loading />}>
                                    <LcaAttemptsRouteDrawer />
                                </Suspense>
                            </RequireAuth>}
                        />
                    </Route>
                    <Route path="b3-custody/lca-credit-rights" element={
                        <RequireAuth roles={B3_CUSTODY_SCREEN_ROLES}>
                            <Suspense fallback={<Loading />}>
                                <CustodyRegistrationPageList />
                            </Suspense>
                        </RequireAuth>}
                    >
                        <Route path="detail/:id" element={
                            <RequireAuth roles={B3_CUSTODY_SCREEN_ROLES}>
                                <Suspense fallback={<Loading />}>
                                    <LcaCreditRightDetailRouteDrawer />
                                </Suspense>
                            </RequireAuth>}
                        />
                        <Route path="attempts/:id" element={
                            <RequireAuth roles={B3_CUSTODY_SCREEN_ROLES}>
                                <Suspense fallback={<Loading />}>
                                    <LcaAttemptsRouteDrawer />
                                </Suspense>
                            </RequireAuth>}
                        />
                    </Route>
                    {/* B3 Custody - Registrations (legacy route) */}
                    <Route path="b3-custody/registrations/:page/:pageSize/:field/:order/:filter?" element={
                        <RequireAuth roles={B3_CUSTODY_SCREEN_ROLES}>
                            <Suspense fallback={<Loading />}>
                                <CustodyRegistrationPageList />
                            </Suspense>
                        </RequireAuth>}
                    >
                        <Route path="detail/:id" element={
                            <RequireAuth roles={B3_CUSTODY_SCREEN_ROLES}>
                                <Suspense fallback={<Loading />}>
                                    <LcaCreditRightDetailRouteDrawer />
                                </Suspense>
                            </RequireAuth>}
                        />
                        <Route path="attempts/:id" element={
                            <RequireAuth roles={B3_CUSTODY_SCREEN_ROLES}>
                                <Suspense fallback={<Loading />}>
                                    <LcaAttemptsRouteDrawer />
                                </Suspense>
                            </RequireAuth>}
                        />
                    </Route>
                    <Route path="b3-custody/registrations" element={
                        <RequireAuth roles={B3_CUSTODY_SCREEN_ROLES}>
                            <Suspense fallback={<Loading />}>
                                <CustodyRegistrationPageList />
                            </Suspense>
                        </RequireAuth>}
                    >
                        <Route path="detail/:id" element={
                            <RequireAuth roles={B3_CUSTODY_SCREEN_ROLES}>
                                <Suspense fallback={<Loading />}>
                                    <LcaCreditRightDetailRouteDrawer />
                                </Suspense>
                            </RequireAuth>}
                        />
                        <Route path="attempts/:id" element={
                            <RequireAuth roles={B3_CUSTODY_SCREEN_ROLES}>
                                <Suspense fallback={<Loading />}>
                                    <LcaAttemptsRouteDrawer />
                                </Suspense>
                            </RequireAuth>}
                        />
                    </Route>
                    {/* B3 Custody - Configuration */}
                    <Route path="b3-custody/configuration" element={
                        <RequireAuth roles={B3_CONFIG_ROLES}>
                            <Suspense fallback={<Loading />}>
                                <CustodyConfigurationPage />
                            </Suspense>
                        </RequireAuth>}
                    />
                    <Route path="b3-custody/configuration/:tab" element={
                        <RequireAuth roles={B3_CONFIG_ROLES}>
                            <Suspense fallback={<Loading />}>
                                <CustodyConfigurationPage />
                            </Suspense>
                        </RequireAuth>}
                    />
                    <Route path="b3-custody/products/:id" element={
                        <RequireAuth roles={B3_CONFIG_ROLES}>
                            <Suspense fallback={<Loading />}>
                                <CustodyProductView />
                            </Suspense>
                        </RequireAuth>}
                    />
                    <Route path="b3-custody/commodities/:id" element={
                        <RequireAuth roles={B3_CONFIG_ROLES}>
                            <Suspense fallback={<Loading />}>
                                <CommodityRouteDrawer />
                            </Suspense>
                        </RequireAuth>}
                    />
                    {/* B3 Custody - Remittances */}
                    <Route path="b3-custody/remittances/:page/:pageSize/:field/:order/:filter?" element={
                        <RequireAuth roles={B3_REMITTANCE_ROLES}>
                            <Suspense fallback={<Loading />}>
                                <RemittancePageList />
                            </Suspense>
                        </RequireAuth>}
                    />
                    <Route path="b3-custody/remittances" element={
                        <RequireAuth roles={B3_REMITTANCE_ROLES}>
                            <Suspense fallback={<Loading />}>
                                <RemittancePageList />
                            </Suspense>
                        </RequireAuth>}
                    />
                    {/* B3 Custody - Instrumentos CPRF (com sub-rota da commodity sobre a lista) */}
                    <Route path="b3-custody/funding-issuances/:page/:pageSize/:field/:order/:filter?" element={
                        <RequireAuth roles={B3_FUNDING_ROLES}>
                            <Suspense fallback={<Loading />}>
                                <FundingIssuancePageList />
                            </Suspense>
                        </RequireAuth>}
                    >
                        <Route path="detail/:id" element={
                            <RequireAuth roles={B3_FUNDING_ROLES}>
                                <Suspense fallback={<Loading />}>
                                    <FundingIssuanceDetailRouteDrawer />
                                </Suspense>
                            </RequireAuth>}
                        />
                    </Route>
                    <Route path="b3-custody/funding-issuances" element={
                        <RequireAuth roles={B3_FUNDING_ROLES}>
                            <Suspense fallback={<Loading />}>
                                <FundingIssuancePageList />
                            </Suspense>
                        </RequireAuth>}
                    >
                        <Route path="detail/:id" element={
                            <RequireAuth roles={B3_FUNDING_ROLES}>
                                <Suspense fallback={<Loading />}>
                                    <FundingIssuanceDetailRouteDrawer />
                                </Suspense>
                            </RequireAuth>}
                        />
                    </Route>
                    <Route path="b3-custody/cpr-instruments/:page/:pageSize/:field/:order/:filter?" element={
                        <RequireAuth roles={B3_CUSTODY_SCREEN_ROLES}>
                            <Suspense fallback={<Loading />}>
                                <CprInstrumentPageList />
                            </Suspense>
                        </RequireAuth>}
                    >
                        <Route path="detail/:id" element={
                            <RequireAuth roles={B3_CUSTODY_SCREEN_ROLES}>
                                <Suspense fallback={<Loading />}>
                                    <CprInstrumentDetailRouteDrawer />
                                </Suspense>
                            </RequireAuth>}
                        />
                        <Route path="detail/:id/payload/:payloadId" element={
                            <RequireAuth roles={B3_CUSTODY_SCREEN_ROLES}>
                                <Suspense fallback={<Loading />}>
                                    <CprInstrumentPayloadRouteDrawer />
                                </Suspense>
                            </RequireAuth>}
                        />
                        <Route path="attempts/:id" element={
                            <RequireAuth roles={B3_CUSTODY_SCREEN_ROLES}>
                                <Suspense fallback={<Loading />}>
                                    <CprAttemptsRouteDrawer />
                                </Suspense>
                            </RequireAuth>}
                        />
                        <Route path="remittances/:id" element={
                            <RequireAuth roles={B3_CUSTODY_SCREEN_ROLES}>
                                <Suspense fallback={<Loading />}>
                                    <CprRemittancesRouteDrawer />
                                </Suspense>
                            </RequireAuth>}
                        />
                        <Route path="guarantors/:id" element={
                            <RequireAuth roles={B3_CUSTODY_SCREEN_ROLES}>
                                <Suspense fallback={<Loading />}>
                                    <CprGuarantorsRouteDrawer />
                                </Suspense>
                            </RequireAuth>}
                        />
                        <Route path="commodity/:commodityId" element={
                            <RequireAuth roles={B3_CONFIG_ROLES}>
                                <Suspense fallback={<Loading />}>
                                    <CommodityRouteDrawer />
                                </Suspense>
                            </RequireAuth>}
                        />
                        <Route path="issuer/:issuerId" element={
                            <RequireAuth roles={B3_CONFIG_ROLES}>
                                <Suspense fallback={<Loading />}>
                                    <IssuerRouteDrawer />
                                </Suspense>
                            </RequireAuth>}
                        />
                    </Route>
                    <Route path="b3-custody/cpr-instruments" element={
                        <RequireAuth roles={B3_CUSTODY_SCREEN_ROLES}>
                            <Suspense fallback={<Loading />}>
                                <CprInstrumentPageList />
                            </Suspense>
                        </RequireAuth>}
                    >
                        <Route path="detail/:id" element={
                            <RequireAuth roles={B3_CUSTODY_SCREEN_ROLES}>
                                <Suspense fallback={<Loading />}>
                                    <CprInstrumentDetailRouteDrawer />
                                </Suspense>
                            </RequireAuth>}
                        />
                        <Route path="detail/:id/payload/:payloadId" element={
                            <RequireAuth roles={B3_CUSTODY_SCREEN_ROLES}>
                                <Suspense fallback={<Loading />}>
                                    <CprInstrumentPayloadRouteDrawer />
                                </Suspense>
                            </RequireAuth>}
                        />
                        <Route path="attempts/:id" element={
                            <RequireAuth roles={B3_CUSTODY_SCREEN_ROLES}>
                                <Suspense fallback={<Loading />}>
                                    <CprAttemptsRouteDrawer />
                                </Suspense>
                            </RequireAuth>}
                        />
                        <Route path="remittances/:id" element={
                            <RequireAuth roles={B3_CUSTODY_SCREEN_ROLES}>
                                <Suspense fallback={<Loading />}>
                                    <CprRemittancesRouteDrawer />
                                </Suspense>
                            </RequireAuth>}
                        />
                        <Route path="guarantors/:id" element={
                            <RequireAuth roles={B3_CUSTODY_SCREEN_ROLES}>
                                <Suspense fallback={<Loading />}>
                                    <CprGuarantorsRouteDrawer />
                                </Suspense>
                            </RequireAuth>}
                        />
                        <Route path="commodity/:commodityId" element={
                            <RequireAuth roles={B3_CONFIG_ROLES}>
                                <Suspense fallback={<Loading />}>
                                    <CommodityRouteDrawer />
                                </Suspense>
                            </RequireAuth>}
                        />
                        <Route path="issuer/:issuerId" element={
                            <RequireAuth roles={B3_CONFIG_ROLES}>
                                <Suspense fallback={<Loading />}>
                                    <IssuerRouteDrawer />
                                </Suspense>
                            </RequireAuth>}
                        />
                    </Route>
                    <Route path="/network-error" element={<NetworkError />} />
                    <Route path="/logout" element={<Logout />} />
                </Route>
                <Route path="*" element={<NotFound />} />
                <Route path="/login" element={<Login />} />

            </Routes>
        </HashRouter >
    );
};
export default AppRoutes;